// imports
import React from 'react';
import { Link } from '@react-router';
import { pxToRem } from '@withjoy/joykit/theme';
import { JoyKitThemeProvider } from '@withjoy/joykit';

// local imports
import { ReactComponent as JoyLogo } from '@assets/joy-logo.svg';
import { CurrencySelector } from '@shared/components/CurrencySelector';
import { TopBarContainer, LogoContainer, CurrencySelectorContainer } from './EventTopBar.styles';

interface EventTopBarProps
  extends Readonly<{
    eventHandle: string;
  }> {}

export const EventTopBar: React.FC<EventTopBarProps> = ({ eventHandle }) => (
  <TopBarContainer>
    <LogoContainer
      as={Link}
      to={`/${eventHandle}`}
    >
      <JoyLogo
        width={pxToRem(48)}
        height={pxToRem(30)}
        color="mono14"
      />
    </LogoContainer>

    <JoyKitThemeProvider>
      <CurrencySelectorContainer>
        <CurrencySelector />
      </CurrencySelectorContainer>
    </JoyKitThemeProvider>
  </TopBarContainer>
);
